import React from "react";
import NumberFormat from "react-number-format";
import {
  FormControl,
  OutlinedInput,
  InputLabel,
  InputAdornment,
} from "@mui/material";
import { isNumericTextboxValid } from "../../../../common/validation";

const PercentFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      allowNegative={false}
      decimalScale={2}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
    />
  );
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      thousandSeparator
      allowNegative={false}
      decimalScale={0}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
    />
  );
};

const TextInput = ({
  id,
  label,
  value,
  adornment,
  className = "",
  type = "text",
  error = false,
  helperText,
  readOnly = false,
  onChange,
  isRequired,
}) => {
  const hasErrorPercentage = (value, error, isRequired) => {
    if (error) return true;
    if (isRequired === true) {
      return !isNumericTextboxValid(parseInt(value), 0, 100) && isRequired;
    } else {
      return !isNumericTextboxValid(parseInt(value), 0, 100);
    }
  };

  if (type === "text") {
    return (
      <FormControl variant="outlined" className={className}>
        <InputLabel htmlFor={id} error={!value}>
          {label}
        </InputLabel>
        <OutlinedInput
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          endAdornment={
            <InputAdornment position="end">{adornment}</InputAdornment>
          }
          autoFocus
          error={!value || error}
        />
      </FormControl>
    );
  }

  if (type === "percent") {
    return (
      <FormControl variant="outlined" className={className}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <OutlinedInput
          id={id}
          type="text"
          value={value}
          onChange={onChange}
          onFocus={() => {
            if (value === 0 || value === "0") {
              onChange({
                target: {
                  value: "",
                },
              });
            }
          }}
          endAdornment={
            <InputAdornment position="end">{adornment}</InputAdornment>
          }
          inputProps={{
            readOnly,
          }}
          inputComponent={PercentFormatCustom}
          error={hasErrorPercentage(value, error, isRequired)}
          helperText={helperText}
        />
      </FormControl>
    );
  }

  return (
    <FormControl variant="outlined" className={className}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <OutlinedInput
        id={id}
        type="text"
        value={value}
        onFocus={() => {
          if (value === 0 || value === "0") {
            onChange({
              target: {
                value: "",
              },
            });
          }
        }}
        onChange={onChange}
        endAdornment={
          <InputAdornment position="end">{adornment}</InputAdornment>
        }
        inputProps={{
          readOnly,
          disabled: readOnly,
        }}
        inputComponent={NumberFormatCustom}
        error={(value === "0" || value === 0 || error) && isRequired}
        helperText={helperText}
      />
    </FormControl>
  );
};

export default TextInput;
